import React, { useState, useEffect, Fragment } from 'react'
import './AddOrEditZone.css';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';
import { addZone, getZone, getZones, updateZone } from '../../services/http';
import { handleMenuSelection, handleSubMenuSelection, reload } from '../../utils/utils';
import Navbar from '../../appShell/Navbar/Navbar';
import Sidebar from '../../appShell/Sidebar/Sidebar';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../Loader/Loader';
import ProcessSpinner from '../ProcessSpinner/ProcessSpinner';

const AddOrEditZone = (props) => {

    const { operationType } = props;
    const [displayLoader, setDisplayLoader] = useState(operationType == "new" ? false : true);
    const [processOngoing, setProcessOngoing] = useState(false)

    const [zoneLabel, setZoneLabel] = useState({ libelle: "" });
    const [showError, setShowError] = useState({
        libelle: false
    });
    const [errorMessage, setErrorMessage] = useState({
        libelle: ""
    })

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const id_zone = useParams()
    const states = useSelector((state) => state, shallowEqual);

    const handleChangeLabel = (e) => {
        var value = e.currentTarget.value;
        setZoneLabel({ ...zoneLabel, libelle: value });
    }


    // To populate the breadcrumb and update the sidebar menu
    useEffect(async () => {
        let type = operationType === "new" ? "Création" : "Modification"
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Paramètres", firstLevelLink: "/zone", secondLevelText: "Zone", secondLevelLink: "", thirdLevelText: type, thirdLevelLink: ""
            }
        });
        handleMenuSelection("settings", dispatch, states);
        handleSubMenuSelection("zone", dispatch)
    }, [])


    const handleAddZone = async (type) => {
        setProcessOngoing(true)
        console.log("Here is zone to add", zoneLabel)
        const reqdata = await addZone(zoneLabel.libelle, states.userToken.access_token);
        if (reqdata.response && reqdata.response.status !== 200) {
            if (reqdata.response.status === 422) {
                setProcessOngoing(false)
                let errorMsg = reqdata.response?.data.error["libelle"][0];
                console.log("Error Msg ", errorMsg)
                setShowError({ ...showError, libelle: true })
                setErrorMessage({ ...errorMessage, libelle: errorMsg })
            } else {
                setProcessOngoing(false)
                console.log(reqdata.response?.data.error)
                toast.error(reqdata.response?.data.error, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } else {
            setProcessOngoing(false)
            toast.success(`Nouvelle zone ${zoneLabel.libelle} ajoutée avec succès !`, {
                position: toast.POSITION.TOP_RIGHT
            });
            setZoneLabel({ ...zoneLabel, libelle: "" })
            let response = await getZones(states.userToken.access_token, 1, "");

            let response_copy = response.data.data?.data?.map(obj => ({ ...obj, showEdit: false, showDelete: false }))

            dispatch({
                type: "SET",
                key: "zoneList",
                payload: response_copy,
            });
            if (type == "retourner") { navigate("/zone") }

        }
    }

    const handleEditZone = async () => {
        setProcessOngoing(true)
        const reqdata = await updateZone(id_zone, zoneLabel.libelle, states.userToken.access_token);
        if (reqdata.response && reqdata.response.status !== 200) {
            if (reqdata.response.status === 422) {
                setProcessOngoing(false)
                let errorMsg = reqdata.response?.data.error["libelle"][0];
                console.log("Error Msg ", errorMsg)
                setShowError({ ...showError, libelle: true })
                setErrorMessage({ ...errorMessage, libelle: errorMsg })
            } else {
                setProcessOngoing(false)
                console.log(reqdata.response?.data.error)
                toast.error(reqdata.response?.data.error, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        } else {
            setProcessOngoing(false)
            toast.success(`Modification effectuée avec succès !`, {
                position: toast.POSITION.TOP_RIGHT
            });
            let response = await getZones(states.userToken.access_token, 1, "");
            let response_copy = response.data.data.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
            dispatch({
                type: "SET",
                key: "zoneList",
                payload: response_copy,
            });

            navigate("/zone")
        }
    }


    useEffect(() => {
        if (zoneLabel.libelle != "") {
            setShowError({ ...showError, libelle: false })
        }
    }, [zoneLabel])


    useEffect(() => {
        if (operationType !== "new") {
            loadZoneData();
        }

    }, [])

    const loadZoneData = async () => {
        const resp = await getZone(id_zone, states.userToken.access_token)
        if (resp.response && resp.response.status !== 200) {
            console.log("data error ", resp.response)
        } else {
            console.log("data data produit", resp.data)
            setZoneLabel({ ...zoneLabel, libelle: resp.data.libelle })
            setDisplayLoader(false)
        }
    }


    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                    <div className="layout-px-spacing m-auto"
                    // style={{paddingTop : "50%"}}
                    >

                        <div className="row layout-top-spacing">
                            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                            </div>
                        </div>
                        {displayLoader == false ?
                            <div className="widget widget-content widget-content-area mx-auto">
                                <div class="modal-header text-center py-2">
                                    <h4 className="">{operationType == "new" ? "Nouvelle Zone" : "Modifier Zone"}</h4>

                                </div>
                                <Modal.Body className="modal-body">
                                    <div class="simple-example  mx-auto">
                                        <div class="form-group mx-auto w-80 row mb-4">
                                            <label for="libelle" class="col-sm-2 col-form-label col-form-label-sm text-dark required">Libelle</label>
                                            <div class="col-sm-10">
                                                <input type="text" onChange={handleChangeLabel} className={showError.libelle == true ? "form-control custom-form-control new-institution-category-error-input  mx-auto" : "form-control custom-form-control form-control-sm mx-auto"} id="colFormLabelSm" placeholder="" value={zoneLabel.libelle} required />
                                                {showError.libelle === true && <span className="new-institution-category-error-span">{errorMessage.libelle}</span>}
                                            </div>
                                        </div>
                                    </div>
                                </Modal.Body>
                                <div className="modal-footer">
                                    {processOngoing == false ? <Fragment>
                                        <button type="button"
                                            title={operationType == "new" ? "Ajouter et rester sur la page" : "Modifier"}
                                            className="btn btn-primary ml-3" onClick={operationType == "new" ? () => handleAddZone("rester") : handleEditZone}>{operationType == "new" ? "Ajouter et Nouveau" : "Modifier"}</button>
                                        {operationType == "new" &&
                                            <button type="button"
                                                title={"Ajouter et retourner à la liste"}
                                                className="btn btn-primary ml-3"
                                                onClick={() => handleAddZone("retourner")}>
                                                Ajouter et Retourner</button>
                                        }
                                    </Fragment> : <ProcessSpinner />}
                                    <button className="btn ml-3" data-dismiss="modal" onClick={() => navigate("/zone")}><i className="flaticon-cancel-12"></i> Retour</button>

                                </div>
                            </div> : <div style={{ marginTop: "25%" }}>
                                <Loader />
                            </div>}
                    </div>

                </div>
            </div>
        </div>

    )
}

export default AddOrEditZone